import { Box } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { STextProps } from '@setvi/shared/components/sui/stext';
import { TextColor } from '@setvi/shared/enums';
import { Product } from '@setvi/shared/interfaces';

export interface PricingProps {
  value: number;
  label?: string;
  size?: STextProps['size'];
}

export const Price = ({ value, label, size }: PricingProps) => (
  <SText
    size={size}
    title={`${label}: ${
      value >= 0 && value !== null
        ? value.toLocaleString('en-US', {
            currency: 'USD',
            style: 'currency'
          })
        : '-'
    }`}
  />
);

export const Cost = ({ value, label, size }: PricingProps) => (
  <SText
    size={size}
    title={`${label}: ${
      value > 0
        ? value.toLocaleString('en-US', {
            currency: 'USD',
            style: 'currency'
          })
        : '-'
    }`}
  />
);

export interface CalculatedPricingProps {
  price: Product['price'];
  cost: Product['cost'];
  label: string;
  size?: STextProps['size'];
}

export const Profit = ({
  price,
  cost,
  label,
  size
}: CalculatedPricingProps) => (
  <Box display="flex">
    <SText
      size={size}
      title={`${label}: ${
        price > cost
          ? (price - cost).toLocaleString('en-US', {
              currency: 'USD',
              style: 'currency'
            })
          : '-'
      }`}
    />
    {price > cost && (
      <SText
        size={size}
        title={`(${(((price - cost) / price) * 100).toFixed(2).toString()}%)`}
        weight="normal"
        fontColor={TextColor.Green}
        style={{ marginLeft: '5px' }}
      />
    )}
  </Box>
);
export const Discount = ({
  price,
  cost,
  label,
  size
}: CalculatedPricingProps) => (
  <Box display="flex">
    <SText
      size={size}
      title={`${label}: ${
        price > cost
          ? (price - cost).toLocaleString('en-US', {
              currency: 'USD',
              style: 'currency'
            })
          : '-'
      }`}
    />
    {price > cost && (
      <SText
        size={size}
        title={`(${(((price - cost) / cost) * 100).toFixed(2).toString()}%)`}
        weight="normal"
        fontColor={TextColor.Green}
        style={{ marginLeft: '5px' }}
      />
    )}
  </Box>
);
